module.exports = __webpack_public_path__ + "static/media/Hidden-Ridge-bylaws.da8f16f4.pdf";